mmf_modules.define('app/navigation/index',['require','exports','module','jquery','utils/touch'],function (require, exports, module) {

  var $ = require('jquery');

  exports.init = function () {
    initTouch();
    initSearch();
  };

  function initTouch () {
    require('utils/touch').init();

    function tapHandler (event) {
      event.originalEvent.preventDefault();
    }

    var dropdowns = document.querySelectorAll('header.nav .nav-menu .js-hasDropdown');
    [].slice.call(dropdowns, 0).forEach(function (elm) {
      elm.addEventListener('tap', tapHandler);
    });
  }

  function initSearch () {
    var $searchForm = $('header.nav .nav-search-form');
    var $searchIcon = $('header.nav .nav-search-icon');
    var $searchField = $('header.nav .nav-search-field');

    var COLLAPSED_CLASS = 'nav-search__collapsed';

    function collapse () {
      $searchForm.addClass(COLLAPSED_CLASS);
      $searchField.prop('disabled', true);
    }

    function expand () {
      $searchForm.removeClass(COLLAPSED_CLASS);
      $searchField.prop('disabled', false);
      $searchField.focus();
    }

    function toggle () {
      if ($searchForm.hasClass(COLLAPSED_CLASS)) {
        expand();
      } else {
        collapse();
      }
    }

    $searchIcon.on('click', toggle);
    $searchField.on('blur', collapse);
  }

});

